/**
 * Strip invisible bidirectional/zero-width control characters that Hebrew
 * (RTL) browsers sometimes inject into text inputs. These characters are
 * legal Unicode but break HTML5 `type="email"` validation, e.g. the user
 * types `fullframe.nd@gmail.com` but the input value actually becomes
 * `fullframe.nd\u200E@gmail.com` and the browser rejects it.
 *
 * Covers: ZWSP, ZWNJ, ZWJ, LRM, RLM, LRE, RLE, PDF, LRO, RLO,
 *         LRI, RLI, FSI, PDI, BOM.
 */
export const stripBidiControls = (s) =>
  String(s ?? "").replace(/[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g, "");

/**
 * Light client-side email format check. Use INSTEAD of the browser's
 * `type="email"` validation, which trips on Hebrew bidi markers.
 */
export const isValidEmail = (s) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(stripBidiControls(s).trim());
